import PropTypes from 'prop-types';
import NotificationComponent from 'Components/Notification';

const Notification = ({ icon, message, messageStringKey, strings }) => (
  <NotificationComponent
    icon={icon}
    message={message || strings[messageStringKey]}
  />
);

Notification.propTypes = {
  icon: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  messageStringKey: PropTypes.string.isRequired,
  strings: PropTypes.object.isRequired,
};

export default Notification;
